import { createClient } from '@supabase/supabase-js';
import { Database } from '../types/supabase';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient<Database>(
  supabaseUrl,
  supabaseKey,
  {
    realtime: {
      params: {
        eventsPerSecond: 10
      }
    }
  }
);

export const pvpService = {
  async findMatch(playerId: string) {
    const { data: queueData } = await supabase
      .from('queue')
      .select('player_id')
      .neq('player_id', playerId)
      .limit(1)
      .single();

    if (queueData) {
      const password = Math.random().toString(36).substring(2, 12);
      await supabase.from('matches').insert([{
        player1_id: playerId,
        player2_id: queueData.player_id,
        password,
        status: 'active'
      }]);

      await supabase
        .from('queue')
        .delete()
        .in('player_id', [playerId, queueData.player_id]);
    }
  }
};